import {scroll} from '../global/locomotive-custom';

/**
 * TODO :
 * Voir si on rend ce code générique (utilisable par plusieurs types de barres de filtres)
 * ou le rendre totalement dépendant à un layout particulier
 * ou à une catégorie de layouts (Ceux qui font des post query par ex)
 */
export default () => {
    const responseContainer = document.querySelector('#posts-container');
    const loader = document.querySelector('#posts-grid-loader');
    const forms = document.querySelectorAll('.query-filters');

    forms.forEach(form => {
        const filters = form.querySelectorAll('.query-filter');

        filters.forEach(filter => {
            filter.addEventListener('click', async () => {
                responseContainer.innerHTML = '';
                if(loader) {
                    loader.classList.add('show');
                }

                let category = filter.dataset.catId;
                let postsPerPage = responseContainer.dataset.postsPerPage;

                if(category) {
                    responseContainer.dataset.currentCategory = category;
                }

                getData(category, postsPerPage).then(data => {
                    loader.classList.remove('show');
                    responseContainer.dataset.paged = 1;
                    responseContainer.innerHTML = data;
                    setTimeout(() => scroll.update(), 100)
                });
            })
        })
    })
}

function getData(category, postsPerPage) {
    return fetch(ajaxConfig.ajax_url, {
        method: 'POST', // POST
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: new URLSearchParams({
            category,
            posts_per_page: postsPerPage,
            action: 'posts_grid_filter_category',
        })

        // beforeSend:function(xhr){
        //     filter.find('button').text('Processing...'); // changing the button label
        // },
    })
        .then(res => res.text())
        .catch(e => console.error(e))
}
